//console.log('main.js');

//Toggle Chat
// let chatBtn = document.querySelector("#toggle-chat-btn");

// chatBtn.addEventListener("click", function (event) {
//   event.preventDefault();
//   chatBtn.classList.add("active");
//   document.querySelector("#shopify-chat").classList.toggle("active");
//   // document.querySelector("#ShopifyChat").dataset.isOpen = "true";
//   document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();
// });

//Desktop Close Button
// function startCheckingForDesktopButton() {
//   const intervalId = setInterval(() => {
//     //console.log("Checking for desktop chat close button...");
//     const shopifyChatElement = document.getElementById("ShopifyChat");

//     if (shopifyChatElement && shopifyChatElement.shadowRoot) {
//       const closeButton = shopifyChatElement.shadowRoot.querySelector('button[aria-label="Chat"]');
  
//       if (closeButton) {
//         closeButton.style.cssText = " opacity: 0;";
//         //clearInterval(intervalId);
//       }
//     }
//   }, 50);
// }

// startCheckingForDesktopButton();

//Mobile Close Button
// function startCheckingForButton() {
//   const intervalId = setInterval(() => {
//     //console.log("Checking for chat close button...");

//     const shopifyChatElement = document.getElementById("ShopifyChat");
//     if (shopifyChatElement && shopifyChatElement.shadowRoot) {
//       const closeButton = shopifyChatElement.shadowRoot.querySelector('button[aria-label="Chat"]');
      
//       if (closeButton) {
//         closeButton.addEventListener("click", function (event) {
//           document.querySelector("#shopify-chat").classList.remove("active");
//           startCheckingForButton();
//         });
//         //clearInterval(intervalId);
//       }
//     }
//   }, 50);
// }

// startCheckingForButton();


window.addEventListener("resize", function () {
  //Auto Heights
  let trueHeight = window.innerHeight;
  let setHeights = document.querySelectorAll(".auto-height");
  setHeights.forEach(function (item, i) {
    item.style.height = trueHeight + "px";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let lastDialogTrigger = null;

  let setControlledButtons = function (panel, expanded) {
    if (!panel || !panel.id) return;
    document
      .querySelectorAll(`[aria-controls="${panel.id}"]`)
      .forEach(function (button) {
        button.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
  };

  let getFocusableElements = function (container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter(function (element) {
      return (
        !element.hidden &&
        element.getAttribute("aria-hidden") !== "true" &&
        element.getClientRects().length > 0
      );
    });
  };

  let openDialog = function (panel, trigger) {
    if (!panel) return;
    lastDialogTrigger = trigger || document.activeElement;
    panel.classList.add("active");
    panel.setAttribute("aria-hidden", "false");
    panel.removeAttribute("inert");
    setControlledButtons(panel, true);
    document.body.classList.add("no-scroll");

    let backdrop = document.querySelector("#pop-bg");
    if (backdrop) backdrop.classList.add("active");

    let focusable = getFocusableElements(panel);
    if (focusable.length > 0) focusable[0].focus();
  };

  window.coAccessibility = window.coAccessibility || {};
  window.coAccessibility.openDialog = openDialog;

  //Auto Heights
  let trueHeight = window.innerHeight;
  let setHeights = document.querySelectorAll(".auto-height");
  setHeights.forEach(function (item, i) {
    item.style.height = trueHeight + "px";
  });

  //Popups
  let sidePops = document.querySelectorAll(".side-pop");
  let closePops = document.querySelectorAll(".close-pop");
  let sidePopCloseBg = document.querySelector("#pop-bg");

  closePops.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      closeSidePops();
      //resetLogin();
    });
  });

  let closeSidePops = function () {
    sidePops.forEach(function (item) {
      item.classList.remove("active");
      item.setAttribute("aria-hidden", "true");
      item.setAttribute("inert", "");
      setControlledButtons(item, false);
    });
    if (sidePopCloseBg) sidePopCloseBg.classList.remove("active");
    siteBody?.classList.remove("no-scroll");
    if (lastDialogTrigger && document.contains(lastDialogTrigger)) {
      lastDialogTrigger.focus();
    }
    lastDialogTrigger = null;
  };

  window.coAccessibility.closeDialogs = closeSidePops;

  //Contact Buttons
  let contactBtns = document.querySelectorAll(".contact-btn");
  let contactPopup = document.querySelector("#side-contact");
  contactBtns.forEach(function (item, i) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      openDialog(contactPopup, item);
    });
  });

  //Sidepop BG Close
  if (sidePopCloseBg) {
    sidePopCloseBg.addEventListener("click", function (event) {
      event.preventDefault();
      closeSidePops();
    });
  }

  //Mobile Nav Button
  let menuBtn = document.querySelector("#menu-btn");
  let mobileNav = document.querySelector("#mobile-nav");
  let siteBody = document.querySelector("body");
  let headerNav = document.querySelector("header");

  menuBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let isOpen = !mobileNav.classList.contains("active");
    menuBtn.classList.toggle("active", isOpen);
    menuBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    menuBtn.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    headerNav.classList.toggle("white", isOpen);
    mobileNav.classList.toggle("active", isOpen);
    mobileNav.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) {
      mobileNav.removeAttribute("inert");
    } else {
      mobileNav.setAttribute("inert", "");
    }
    siteBody.classList.toggle("no-scroll", isOpen);

    if (isOpen) {
      mobileNav.querySelector(".mobile-menu-btn")?.focus();
    }
  });

  //Page Head
  let pageHeads = document.querySelectorAll(".page-head");

  pageHeads.forEach(function (pageHead) {
    let readBtn = pageHead.querySelector(".read-more");
    if (readBtn) {
      let short = pageHead.querySelector(".short");
      let full = pageHead.querySelector(".full");

      readBtn.addEventListener("click", function (event) {
        event.preventDefault();
        readBtn.classList.add("hide");
        short.classList.add("hide");
        full.classList.remove("hide");
      });
    }
  });


  //Cart Button
  let cartBtn = document.querySelectorAll(".cart-btn");
  let sideCart = document.querySelector("#side-cart");
  cartBtn.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      openDialog(sideCart, item);
    });
  });

  //Search Button
  let searchBtn = document.querySelectorAll(".search-btn");
  let searchCon = document.querySelector("#search-header");
  let closeSearchBtn = document.querySelectorAll(".close-search-btn");

  searchBtn.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Search Header");
      let isOpen = !searchCon.classList.contains("open");
      searchCon.classList.toggle("open", isOpen);
      searchCon.setAttribute("aria-hidden", isOpen ? "false" : "true");
      if (isOpen) {
        searchCon.removeAttribute("inert");
      } else {
        searchCon.setAttribute("inert", "");
      }
      searchBtn.forEach(function (button) {
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
      if (isOpen) {
        lastDialogTrigger = item;
        siteBody.classList.add("no-scroll");
        searchCon.querySelector("#search-input").focus();
      }
    });
  });

  closeSearchBtn.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Close Seach");
      document.querySelector("#search-input").value = "";
      document.querySelector("#search-results").innerHTML = "";
      document.querySelector("#showing-top-results").classList.add("hide");
      document.querySelector("#show-more").classList.add("hide");
      searchCon.classList.remove("open");
      searchCon.setAttribute("aria-hidden", "true");
      searchCon.setAttribute("inert", "");
      searchBtn.forEach(function (button) {
        button.setAttribute("aria-expanded", "false");
      });
      siteBody.classList.remove("no-scroll");
      if (lastDialogTrigger && document.contains(lastDialogTrigger)) {
        lastDialogTrigger.focus();
      }
      lastDialogTrigger = null;
    });
  });

  document.addEventListener("keydown", function (event) {
    let linkButton = event.target.closest('a[role="button"]');
    if (event.key === " " && linkButton) {
      event.preventDefault();
      linkButton.click();
      return;
    }

    if (event.key === "Escape") {
      if (searchCon?.classList.contains("open")) {
        document.querySelector(".close-search-btn")?.click();
        return;
      }

      if (mobileNav?.classList.contains("active")) {
        menuBtn.click();
        menuBtn.focus();
        return;
      }

      if (document.querySelector(".side-pop.active")) {
        closeSidePops();
        return;
      }
    }

    if (event.key !== "Tab") return;
    let activeDialog = document.querySelector(
      '.side-pop.active[role="dialog"], #search-header.open[role="dialog"]',
    );
    if (!activeDialog) return;

    let focusable = getFocusableElements(activeDialog);
    if (focusable.length === 0) return;

    let first = focusable[0];
    let last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  //Non recurring membership button
  let membershipBtn = document.querySelectorAll(".upsell-btn");
  if (membershipBtn.length > 0) {
    membershipBtn.forEach(function (item) {
      item.addEventListener("click", function (event) {
        event.preventDefault();

        // fetch('/cart/add.js', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   },
        //   body: JSON.stringify({
        //     id: 45437566025974,
        //     quantity: 1
        //   })
        // })
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              id: 46021519376630,
              quantity: 1,
              selling_plan: 3454730486,
            }),
          })
          .then((response) => response.json())
          .then((data) => {
            //console.log("Item added to cart!", data);
            openDialog(document.querySelector("#side-cart"), item);
            displayCart();
          })
          .catch((error) => console.error("Error adding item to cart:", error));
      });
    });
  }


  //Recurring Membership Button
  let recurringMembershipBtn = document.querySelectorAll(
    ".recurring-upsell-btn"
  );
  if (recurringMembershipBtn.length > 0) {
    recurringMembershipBtn.forEach(function (item) {
      item.addEventListener("click", function (event) {
        event.preventDefault();

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: 46021519376630,
            quantity: 1,
            selling_plan: 3454730486,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Item added to cart!", data);
            openDialog(document.querySelector("#side-cart"), item);
            displayCart();
          })
          .catch((error) => console.error("Error adding item to cart:", error));
      });
    });
  }
});

//Mobile Block Menus
let menuBtns = document.querySelectorAll(".mobile-menu-btn");
let menuBlocks = document.querySelectorAll(".mobile-menu-block");

menuBtns.forEach(function (item, i) {
  item.addEventListener("click", function (event) {
    event.preventDefault();
    resetMenus(i);
  });
});

let resetMenus = function (i) {
  menuBlocks.forEach(function (item, j) {
    let isSelected = i === j;
    item.classList.toggle("active", isSelected);
    item.hidden = !isSelected;
    menuBtns[j].classList.toggle("active", isSelected);
    menuBtns[j].setAttribute("aria-selected", isSelected ? "true" : "false");
    menuBtns[j].setAttribute("tabindex", isSelected ? "0" : "-1");
  });
};

menuBtns.forEach(function (button, index) {
  button.addEventListener("keydown", function (event) {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    event.preventDefault();
    let direction = event.key === "ArrowRight" ? 1 : -1;
    let nextIndex = (index + direction + menuBtns.length) % menuBtns.length;
    resetMenus(nextIndex);
    menuBtns[nextIndex].focus();
  });
});

//Search Count
let searchCount = document.querySelector("#search-results span");

if(searchCount){
  let realCount = document.querySelector("#real-count").innerHTML;
  searchCount.innerHTML = realCount;
}

//Colelctions Mobile NAv Drop
let collectionsDropBtn = document.querySelector(".collections-drop-btn");
let collectionLinks = document.querySelectorAll(".collections-link");

if(collectionsDropBtn){
collectionsDropBtn.addEventListener("click", function (event) {
  event.preventDefault();
  collectionLinks.forEach(function (item) {
    item.classList.add("show");
  });
});
}

//Newsletter
let newsletterFormWrap = document.querySelectorAll('.newsletter-form');

if (newsletterFormWrap.length > 0) {
  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector('form');
    let newsletterEmail = item.querySelector('.newsletter-email');
    let successMessage = item.querySelector('.success');

    newsletterForm.addEventListener('submit', function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "email-capture-footer",
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "Wfa5tP",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=YB3duh', requestOptions)
        .then((res) => {
          if (res.ok) {
            // Check if there is content to parse
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          console.log('Submission successful:', res);
          newsletterForm.classList.add('hide');
          successMessage.classList.remove('hide');
        })
        .catch((err) => {
          console.error('Error occurred:', err);
          //successMessage.classList.add('hide');
        });
    });
  });
}

//Country Select

// let sideCountry = document.querySelector("#side-country");
// let countrySelect = document.querySelector("#country-selector");

// if (countrySelect) {
//   countrySelect.addEventListener("click", function (event) {
//     event.preventDefault();
//     sideCountry.classList.toggle("active");
//   });
// }

document.addEventListener("DOMContentLoaded", () => {
  const selectors = document.querySelectorAll('.md-footer-selector__content .md-form__select, .md-footer-selector__content .md-form__select__country__list, .md-footer-selector__content .md-form__select__language__list');

  selectors.forEach(el => {
    el.style.setProperty('border', '1px solid #eee', 'important');
  });

  const selectWithArrow = document.querySelectorAll('.md-footer-selector__content .md-form__select');

  selectWithArrow.forEach(el => {
    el.style.setProperty('background-image', 'url(https://cdn.shopify.com/s/files/1/0024/3918/4502/files/arrow-down.jpg?v=1746037711)', 'important');
  });
});


//Banner
document.addEventListener('DOMContentLoaded', function () {
  var verticalSwiperEl = document.querySelector('.banner-swiper');

  if (verticalSwiperEl) {
    new Swiper(verticalSwiperEl, {
      direction: 'vertical',
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      allowTouchMove: false,
    });
  }
});

// document.addEventListener("la:dn:promotions:loaded", function (event) {
//   const promotions = event.detail.data[0];
//   console.log("Promotions loaded", promotions);
// });


// document.addEventListener("la:dn:cart:updated", function (event) {
//   const discountedCart = event.detail.data[0];
//   console.log("Discounted cart available", discountedCart);
// });

document.addEventListener("DOMContentLoaded", function () {
  var megaMenus = document.querySelectorAll(
    ".shop-mega-menu, .collection-mega-menu",
  );

  megaMenus.forEach(function (megaMenu) {
    var menuItem = megaMenu.closest(".has-child");
    var menuTrigger = menuItem?.querySelector(`[aria-controls="${megaMenu.id}"]`);

    function setMenuOpen(isOpen) {
      if (!menuItem || !menuTrigger) return;
      menuItem.classList.toggle("show", isOpen);
      menuTrigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      megaMenu.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }

    menuItem?.addEventListener("mouseenter", function () {
      setMenuOpen(true);
    });

    menuItem?.addEventListener("mouseleave", function () {
      setMenuOpen(false);
    });

    menuItem?.addEventListener("focusin", function () {
      setMenuOpen(true);
    });

    menuItem?.addEventListener("focusout", function () {
      window.setTimeout(function () {
        if (!menuItem.contains(document.activeElement)) setMenuOpen(false);
      }, 0);
    });

    if (menuTrigger?.tagName === "BUTTON") {
      menuTrigger.addEventListener("click", function () {
        setMenuOpen(menuTrigger.getAttribute("aria-expanded") !== "true");
      });
    }

    menuItem?.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      setMenuOpen(false);
      menuTrigger?.focus();
    });

    var dropdownImage = megaMenu.querySelector(".dropdown-image .fg-image");

    if (!dropdownImage) {
      return;
    }

    var defaultImage =
      dropdownImage.getAttribute("data-default") ||
      dropdownImage.getAttribute("src");
    var links = megaMenu.querySelectorAll("a[data-img]");
    var isAnimating = false;
    var imageCache = {};

    function preloadImage(src) {
      if (!src || imageCache[src]) {
        return;
      }

      var img = new Image();
      img.src = src;
      imageCache[src] = true;
    }

    preloadImage(defaultImage);

    links.forEach(function (link) {
      var hoverImage = link.getAttribute("data-img");

      if (hoverImage && hoverImage.trim() !== "") {
        preloadImage(hoverImage);
      }
    });

    function swapImage(newSrc) {
      if (
        !newSrc ||
        newSrc === dropdownImage.getAttribute("src") ||
        isAnimating
      ) {
        return;
      }

      isAnimating = true;

      dropdownImage.classList.add("is-fading-out");

      setTimeout(function () {
        dropdownImage.setAttribute("src", newSrc);
        dropdownImage.classList.remove("is-fading-out");
        isAnimating = false;
      }, 120);
    }

    links.forEach(function (link) {
      link.addEventListener("mouseenter", function () {
        var hoverImage = link.getAttribute("data-img");

        if (hoverImage && hoverImage.trim() !== "") {
          swapImage(hoverImage);
        }
      });
    });

    megaMenu.addEventListener("mouseleave", function () {
      swapImage(defaultImage);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function syncMenuImageSize() {
    var shopMenuImage = document.querySelector(
      "header .shop-mega-menu .dropdown-image",
    );
    var collectionMenuImage = document.querySelector(
      "header .collection-mega-menu .dropdown-image",
    );

    if (!shopMenuImage || !collectionMenuImage) {
      return;
    }

    var shopWidth = shopMenuImage.offsetWidth;
    var shopHeight = shopMenuImage.offsetHeight;

    collectionMenuImage.style.width = shopWidth + "px";
    collectionMenuImage.style.height = shopHeight + "px";
  }

  syncMenuImageSize();
  window.addEventListener("resize", syncMenuImageSize);
});

//Newsletter
// let newsletterFormWrapSpring = document.querySelectorAll('.newsletter-form-sale');

// let params = new URLSearchParams(window.location.search);

// if (params.get("access") === "spring") {
//   //document.body.classList.add("sale-access");
//   Cookies.set("newsletter-page", "subscribed", { expires: 30 });
//   document.querySelector(".collection-newsletter-pg").classList.add("show");
// }

Cookies.remove("newsletter-page");
